import PushNotificationActionCreator from "@/helpers/push/creators/PushNotificationActionCreator";
import ViewAppointmentAction from "@/helpers/push/actions/ViewAppointmentAction";
export default class ViewAppointmentActionCreator extends PushNotificationActionCreator {
    payload;
    constructor(payload) {
        super();
        this.payload = payload;
    }
    create() {
        return new ViewAppointmentAction(this.payload.type, this.payload.id, this.payload.educationClass);
    }
}
